export default __webpack_public_path__ + "static/media/sde1.15470f75.svg";